import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      margin: theme.spacing(0, 0, 1, 1.75),
    },
  };
};
